/* KALMO — cart, product forms, gallery */
(() => {
  'use strict';
  const { $, $$, reduced, root, openLayer, money } = window.K;
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-k-step]'); if (!b) return;
    const input = b.closest('.k-qty').querySelector('input');
    const min = parseInt(input.min || '0', 10), max = parseInt(input.max || '999', 10);
    const v = Math.min(max, Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(b.dataset.kStep, 10)));
    input.value = v; input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  const Cart = {
    el: null,
    get drawer() { return this.el || (this.el = $('#k-cart')); },
    async fetch() { const r = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }); return r.json(); },
    async open() { const d = this.drawer; if (!d) { location.href = root + 'cart'; return; } openLayer(d); await this.refresh(); },
    async refresh() { const d = this.drawer; if (!d) return; d.classList.add('is-loading'); try { this.render(await this.fetch()); } finally { d.classList.remove('is-loading'); } },
    count(n) {
      $$('[data-k-cart-count]').forEach((c) => {
        c.textContent = n; c.hidden = n === 0; c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump');
      });
      $$('[data-k-cart-label]').forEach((l) => l.setAttribute('aria-label', `Košík, počet položek: ${n}`));
    },
    render(cart) {
      const d = this.drawer; this.count(cart.item_count);
      const body = $('[data-k-cart-body]', d), foot = $('[data-k-cart-foot]', d), cnt = $('[data-k-cart-items]', d);
      if (cnt) cnt.textContent = cart.item_count ? `(${cart.item_count})` : '';
      if (!cart.item_count) {
        body.innerHTML = $('#k-cart-empty').innerHTML; foot.hidden = true; return;
      }
      foot.hidden = false;
      $('[data-k-cart-total]', d).textContent = money(cart.total_price);
      body.innerHTML = cart.items.map((it, n) => {
        const img = it.image ? `<img src="${it.image}${it.image.includes('?') ? '&' : '?'}width=200" alt="" width="84" height="84" loading="lazy">` : '<span></span>';
        const variant = it.variant_title && it.variant_title !== 'Default Title' ? `<div class="k-note">${esc(it.variant_title)}</div>` : '';
        return `<div class="k-line" data-key="${it.key}">
          ${img}
          <div>
            <div class="k-line__top"><a class="k-line__title" href="${it.url}">${esc(it.product_title)}</a><span class="k-line__price">${money(it.final_line_price)}</span></div>
            ${variant}
            <div class="k-line__bottom">
              <div class="k-qty" role="group" aria-label="Množství – ${esc(it.product_title)}">
                <button type="button" data-k-step="-1" aria-label="Snížit množství">${ICON.minus}</button>
                <input type="number" inputmode="numeric" min="0" max="99" value="${it.quantity}" data-k-line="${n + 1}" aria-label="Množství">
                <button type="button" data-k-step="1" aria-label="Zvýšit množství">${ICON.plus}</button>
              </div>
              <button type="button" class="k-line__remove" data-k-remove="${n + 1}">Odebrat</button>
            </div>
          </div></div>`;
      }).join('');
    },
    async change(line, quantity) {
      const d = this.drawer; d.classList.add('is-loading');
      try {
        const r = await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) });
        const data = await r.json();
        if (!r.ok) throw new Error(data.description || data.message);
        this.render(data);
      } catch (err) {
        this.render(await this.fetch());
        const msg = $('[data-k-cart-error]', d); if (msg) { msg.hidden = false; msg.textContent = 'Množství se nepodařilo změnit. Zkuste to prosím znovu.'; setTimeout(() => { msg.hidden = true; }, 4000); }
      } finally { d.classList.remove('is-loading'); }
    },
    async add(id, quantity) {
      const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id, quantity }] }) });
      const data = await r.json(); if (!r.ok) throw new Error(data.description || data.message || 'error');
      return data;
    }
  };
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const ICON = {
    minus: '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8h10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>',
    plus: '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8h10M8 3v10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>'
  };
  document.addEventListener('change', (e) => {
    const inp = e.target.closest('[data-k-line]'); if (!inp) return;
    clearTimeout(inp._t); inp._t = setTimeout(() => Cart.change(parseInt(inp.dataset.kLine, 10), Math.max(0, parseInt(inp.value, 10) || 0)), 250);
  });
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-k-remove]'); if (!b) return;
    Cart.change(parseInt(b.dataset.kRemove, 10), 0);
  });

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-k-buy]'); if (!form) return;
    e.preventDefault();
    const btn = e.submitter && e.submitter.matches('button') ? e.submitter : $('[type="submit"]', form);
    const buyNow = btn && btn.hasAttribute('data-k-buy-now');
    const id = parseInt(form.querySelector('[name="id"]').value, 10);
    const qtyEl = form.querySelector('[name="quantity"]');
    const qty = Math.max(1, parseInt(qtyEl ? qtyEl.value : '1', 10) || 1);
    const err = $('[data-k-buy-error]', form);
    if (err) err.hidden = true;
    const label = btn ? btn.querySelector('[data-label]') : null; const orig = label ? label.textContent : '';
    if (btn) { btn.setAttribute('aria-busy', 'true'); if (label) label.textContent = buyNow ? 'Přesměrováváme…' : 'Přidáváme…'; }
    try {
      await Cart.add(id, qty);
      if (buyNow) { location.href = root + 'checkout'; return; }
      if (label) label.textContent = 'Přidáno';
      await Cart.open();
    } catch (ex) {
      if (err) { err.hidden = false; err.textContent = 'Produkt se nepodařilo přidat do košíku. ' + (ex.message && ex.message !== 'error' ? ex.message : 'Zkuste to prosím znovu.'); }
    } finally {
      if (btn) { btn.removeAttribute('aria-busy'); setTimeout(() => { if (label) label.textContent = orig; }, 1200); }
    }
  });

  $$('[data-k-gallery]').forEach((g) => {
    const track = $('.k-slides', g); const slides = $$('.k-slide', g);
    const thumbs = $$('.k-thumb', g); const dots = $$('.k-gallery__nav button', g);
    let current = 0;
    const mark = (n) => {
      current = n;
      thumbs.forEach((t, i) => t.setAttribute('aria-current', String(i === n)));
      dots.forEach((t, i) => t.setAttribute('aria-current', String(i === n)));
      slides.forEach((s, i) => { s.setAttribute('aria-hidden', String(i !== n)); s.inert = i !== n; if (i !== n) { const v = $('video', s); if (v && !v.paused) v.pause(); } });
    };
    const go = (n) => { n = Math.max(0, Math.min(slides.length - 1, n)); track.scrollTo({ left: slides[n].offsetLeft - track.offsetLeft, behavior: reduced.matches ? 'auto' : 'smooth' }); mark(n); };
    thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
    dots.forEach((t, i) => t.addEventListener('click', () => go(i)));
    $('[data-k-prev]', g)?.addEventListener('click', () => go(current - 1));
    $('[data-k-next]', g)?.addEventListener('click', () => go(current + 1));
    track.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); } });
    let st; track.addEventListener('scroll', () => { clearTimeout(st); st = setTimeout(() => { const n = Math.round(track.scrollLeft / track.clientWidth); if (n !== current) mark(n); }, 80); }, { passive: true });
    mark(0);
  });

  const lb = $('#k-lightbox');
  if (lb && typeof lb.showModal === 'function') {
    const img = $('img', lb);
    document.addEventListener('click', (e) => {
      const z = e.target.closest('[data-k-zoom]'); if (!z) return;
      img.src = z.dataset.kZoom; img.alt = z.dataset.alt || ''; img.classList.remove('is-zoomed'); lb.showModal();
    });
    img.addEventListener('click', () => img.classList.toggle('is-zoomed'));
    $('[data-k-lb-close]', lb).addEventListener('click', () => lb.close());
    lb.addEventListener('click', (e) => { if (e.target === lb || e.target.classList.contains('k-lightbox__inner')) lb.close(); });
  }

  const sticky = $('.k-sticky'); const anchor = $('[data-k-sticky-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    document.body.classList.add('k-has-sticky');
    const footer = $('.k-footer');
    let anchorGone = false, footerIn = false;
    const upd = () => { const on = anchorGone && !footerIn; sticky.classList.toggle('is-on', on); sticky.inert = !on; sticky.setAttribute('aria-hidden', String(!on)); };
    new IntersectionObserver(([en]) => { anchorGone = !en.isIntersecting && en.boundingClientRect.top < 0; upd(); }).observe(anchor);
    if (footer) new IntersectionObserver(([en]) => { footerIn = en.isIntersecting; upd(); }).observe(footer);
    upd();
  }

  document.addEventListener('submit', (e) => {
    const f = e.target; if (!f.matches('form.k-form')) return;
    if (!f.checkValidity()) { e.preventDefault(); const first = f.querySelector(':invalid'); if (first) first.focus(); }
  });
  const MSG = { valueMissing: 'Vyplňte prosím toto pole.', typeMismatch: 'Zadejte prosím platnou e-mailovou adresu.', tooShort: 'Text je příliš krátký.' };
  document.addEventListener('invalid', (e) => {
    const f = e.target; if (!f.closest('.k-form')) return;
    e.preventDefault();
    let m = ''; for (const k in MSG) if (f.validity[k]) { m = MSG[k]; break; }
    if (f.type === 'radio') m = 'Vyberte prosím hodnocení.';
    f.setAttribute('aria-invalid', 'true');
    const box = f.closest('.k-field')?.querySelector('.k-field__err'); if (box) box.textContent = m;
    const firstInvalid = f.form && f.form.querySelector(':invalid'); if (firstInvalid === f) f.focus();
  }, true);
  document.addEventListener('input', (e) => {
    const f = e.target; if (!f.closest('.k-form') || !f.hasAttribute('aria-invalid')) return;
    if (f.checkValidity()) { f.removeAttribute('aria-invalid'); const box = f.closest('.k-field')?.querySelector('.k-field__err'); if (box) box.textContent = ''; }
  });

  document.addEventListener('cart:update', () => Cart.refresh());
  window.KalmoCart = Cart;
})();